export const SORA_MODULES = {
  ALL: 'ALL',
  REST: 'REST',
  DOCUMENTS: 'DOCUMENTS',
  AI: 'AI',
  HOLIDAYS: 'HOLIDAYS',
};
